export function getInitialsFromName(name: string): string {
  const trimmed = name.trim()
  if (!trimmed) return '?'

  const parts = trimmed.split(/\s+/).filter(Boolean)
  if (parts.length >= 2) {
    const first = parts[0].charAt(0)
    const second = parts[1].charAt(0)

    return `${first}${second}`.toUpperCase()
  }
  const first = trimmed.slice(0, 2)

  return first.toUpperCase()
}

export function getFirstAndLastName(fullName: string): { firstName: string; lastName: string } {
  const trimmed = fullName.trim()
  if (!trimmed) return { firstName: '', lastName: '' }

  const parts = trimmed.split(/\s+/).filter(Boolean)
  if (parts.length >= 2) {
    return {
      firstName: parts[0],
      lastName: parts.slice(1).join(' ')
    }
  }

  return { firstName: trimmed, lastName: '' }
}

export function formatDeliveryAddress(recipient: {
  streetAddress: string
  city: string
  stateProvince: string
  postalCode: string
  country: string
}): { line1: string; line2: string; line3: string } {
  const line1 = recipient.streetAddress || ''
  const line2 = [recipient.city, recipient.stateProvince, recipient.postalCode].filter(Boolean).join(', ')
  const line3 = recipient.country || ''

  return { line1, line2, line3 }
}
